export default "__VITE_ASSET__D$bqSG$q__"